module.exports = __webpack_public_path__ + "img/icon-category-trailer.f0fe98a8.png";